<template>
    <div>
        <zm-row>
            <zm-button @click="showCreate" type="primary" plain
            v-if="secret.keyType !== 'ENCRYPT' && secret.shareType !== 'REFERENCE'
            && buttonPermission(secret.applicationId, secret.isSensitive)">Add New Version</zm-button>
        </zm-row>
    <div class="table-container">
        <zm-table :data="list.slice((pageable.pageNo - 1) * pageable.pageSize, pageable.pageNo * pageable.pageSize)" v-loading="loading">
            <zm-table-column label="Version Id" prop="versionId"></zm-table-column>
            <zm-table-column label="Stage" prop="versionStage" width="240px" :filter-method="filterHandler" show-overflow-tooltip
            :filters="[{text: 'previous', value: 'previous'}, {text: 'current', value: 'current'},{text: 'revoked', value: 'revoked'},{text: 'pending', value: 'pending'}]">
                <template slot-scope="scope">
                    <zm-tag v-if="scope.row.versionStage.toLowerCase().indexOf('current') > -1" type="success" size="small">{{ scope.row.versionStage }}</zm-tag>
                    <zm-tag v-if="scope.row.versionStage.toLowerCase().indexOf('previous') > -1" type="warning" size="small">{{ scope.row.versionStage }}</zm-tag>
                    <zm-tag v-if="scope.row.versionStage.toLowerCase().indexOf('pending') > -1" type="" size="small">{{ scope.row.versionStage }}</zm-tag>
                    <zm-tag v-if="scope.row.versionStage.toLowerCase().indexOf('revoked') > -1" size="small">{{ scope.row.versionStage }}</zm-tag>
                </template>
            </zm-table-column>
            <zm-table-column label="Create Time" prop="createTime" width="200px"></zm-table-column>
            <zm-table-column>
                <template slot-scope="scope">
                    <zm-button type="text" @click="showCheck(scope.row.secretHashValue)">verify secret</zm-button>
                    <zm-button type="text" @click="showRevoke(scope.row.versionId)"
                    v-if="(scope.row.versionStage.toLowerCase().indexOf('previous') > -1 || scope.row.versionStage.toLowerCase().indexOf('pending') > -1)
                    && (secret.keyType !== 'ENCRYPT' && secret.shareType !== 'REFERENCE')
                    && buttonPermission(secret.applicationId, secret.isSensitive)">revoke</zm-button>
                    <zm-button type="text" @click="showUpdateToCurrent(scope.row.versionId)"
                    v-if="scope.row.versionStage.toLowerCase().indexOf('pending') > -1
                    && (secret.keyType !== 'ENCRYPT' && secret.shareType !== 'REFERENCE')
                    && buttonPermission(secret.applicationId, secret.isSensitive)">update to current</zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination
                @size-change="handleSizeChange"
                :current-page.sync="pageable.pageNo"
                :page-sizes="[5, 10, 20, 50, 100]"
                :page-size="pageable.pageSize"
                layout="sizes, total, prev, pager, next"
                :total="list.length">
            </zm-pagination>
        </div>
        </div>
        <zm-dialog title="Add New Version" :visible.sync="visible" show-close>
            <zm-form label-width="100px">
                <zm-form-item label="Alias">{{ secret.alias }}
                </zm-form-item>
                <zm-form-item label="Input Type">
                    <zm-radio-group v-model="form.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="form.secretType === 'file' ? '' : 'secret'">
                    <zm-input v-if="form.secretType === 'text'" type="textarea" size="small" v-model="form.secret"></zm-input>
                    <zm-upload
                        v-if="form.secretType === 'file'"
                        :action="getAddVersionAction()"
                        ref="addVersionUpload"
                        id="demo-upload"
                        :file-list="form.fileList"
                        :headers="headers"
                        :on-success="addVersionUploadSuccess"
                        :on-error="addVersionUploadError"
                        :data="form"
                        :auto-upload="false"
                        :http-request="addVersionUpload"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" @click="createVersion" type="primary" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog :title="searchHashForm.title" :visible.sync="searchHashForm.visible" show-close>
            <zm-form label-width="120px">
                <zm-form-item label="Input Type">
                    <zm-radio-group size="small" v-model="searchHashForm.secretType">
                        <zm-radio label="text">Text</zm-radio>
                        <zm-radio label="file">File</zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="Secret" :prop="searchHashForm.secretType === 'file' ? '' : 'secret'">
                    <zm-input v-if="searchHashForm.secretType === 'text'" type="textarea" size="small"
                    v-model="searchHashForm.secret"></zm-input>
                    <zm-upload
                        v-if="searchHashForm.secretType === 'file'"
                        :action="getHashAction()"
                        ref="hashUpload"
                        id="demo-upload"
                        :file-list="searchHashForm.fileList"
                        :headers="headers"
                        :on-success="hashUploadSuccess"
                        :on-error="hashUploadError"
                        :data="searchHashForm"
                        :auto-upload="false"
                        >
                        <zm-button size="small" type="primary">click to upload</zm-button>
                        <div slot="tip" class="zm-upload__tip">limited in 65535 byte</div>
                    </zm-upload>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="searchHashForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="hashSecret" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Confirm Update To Current" :visible.sync="updateForm.visible" show-close>
            Please repeat versionIds to confirm operation of moving 'AWSCURRNT' stage from <em>{{ updateForm.fromId }}</em> to <em>{{ updateForm.toId }}</em>
            <zm-form label-width="80px">
                <zm-form-item label="from">
                    <zm-input v-model.trim="updateForm.repeatFromId"></zm-input>
                </zm-form-item>
                <zm-form-item label="to" >
                    <zm-input v-model.trim="updateForm.repeatToId"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="updateForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="updateToCurrent" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Confirm Revoke" :visible.sync="revokeForm.visible" show-close>
            Please repeat versionId to confirm operation of revoking <em>{{ revokeForm.versionId }}</em>
            <zm-form label-width="150px">
                <zm-form-item label="repeat version id">
                    <zm-input v-model.trim="revokeForm.repeatVersionId"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="revokeForm.visible = false">Close</zm-button>
                <zm-button size="small" type="primary" @click="revokeVersion" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listVersion, addVersion, updateToCurrent, revokeVersion } from '@/api/version'
import { hashSecret } from '@/api/index'
import axios from 'axios'
export default {
    name: 'versionList',
    props: ['secret', 'permission'],
    data () {
        return {
            loading: false,
            list: [],
            visible: false,
            form: {
                id: '',
                secretType: '',
                secret: '',
                fileList: []
            },
            searchHashForm: {
                visible: false,
                secretType: 'text',
                fileList: [],
                hashValue: '',
                secret: ''
            },
            updateForm: {
                visible: false,
                fromId: '',
                toId: '',
                repeatFromId: '',
                repeatToId: ''
            },
            revokeForm: {
                visible: false,
                versionId: '',
                repeatVersionId: ''
            },
            pageable: {
                pageNo: 1,
                pageSize: 10
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.token
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        buttonPermission (appId, secret) {
            const isSensitive = secret ? 'sensitive' : 'insensitive'
            return this.permission.manageableResources.indexOf(appId + '-' + isSensitive) > -1 || this.permission.manageableResources.indexOf('*-' + isSensitive) > -1
        },
        handleSizeChange (val) {
            this.pageable.pageSize = val
        },
        fetchData () {
            this.loading = true
            listVersion(this.secret.id).then(response => {
                this.list = response.data
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showCreate () {
            this.form.id = this.secret.id
            this.form.secret = ''
            this.visible = true
        },
        showCheck (hashValue) {
            this.searchHashForm.title = 'Verify Secret Value'
            this.searchHashForm.secret = ''
            this.searchHashForm.hashValue = hashValue
            this.searchHashForm.visible = true
        },
        showUpdateToCurrent (versionId) {
            this.list.map(item => {
                if (item.versionStage === 'AWSCURRENT') {
                    this.updateForm.fromId = item.versionId
                }
            })
            this.updateForm.toId = versionId
            this.updateForm.repeatFromId = ''
            this.updateForm.repeatToId = ''
            this.updateForm.visible = true
        },
        updateToCurrent () {
            const { fromId, toId, repeatFromId, repeatToId } = this.updateForm
            if (fromId === repeatFromId && toId === repeatToId) {
                const formData = new FormData()
                formData.append('id', this.secret.id)
                formData.append('removeFromVersionId', fromId)
                formData.append('moveToVersionId', toId)
                this.loading = true
                updateToCurrent(formData).then(() => {
                    this.fetchData()
                    this.$message.success('Update to CURRENT success')
                    this.updateForm.visible = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message.warning('Wrong versionId')
            }
        },
        showRevoke (versionId) {
            this.revokeForm.versionId = versionId
            this.revokeForm.repeatVersionId = ''
            this.revokeForm.visible = true
        },
        revokeVersion () {
            const { versionId, repeatVersionId } = this.revokeForm
            if (versionId === repeatVersionId) {
                const formData = new FormData()
                formData.append('id', this.secret.id)
                formData.append('versionId', versionId)
                this.loading = true
                revokeVersion(formData).then(() => {
                    this.fetchData()
                    this.$message.success('Revoke success')
                    this.revokeForm.visible = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.$message.warning('Wrong versionId')
            }
        },
        filterHandler (value, row, column) {
            return row.versionStage.toLowerCase().indexOf(value) > -1
        },
        getAddVersionAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/addVersion'
        },
        createVersion () {
            if (this.form.secretType === 'file') {
                if (this.$refs.addVersionUpload.uploadFiles.length) {
                    this.$refs.addVersionUpload.submit()
                } else {
                    this.$message.warning('Please select a file')
                }
            } else {
                const { id, secret } = this.form
                const formData = new FormData()
                formData.append('secret', secret)
                formData.append('id', id)
                this.loading = true
                addVersion(formData).then(response => {
                    this.$message.success('Add version success')
                    this.loading = false
                    this.fetchData()
                    this.visible = false
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        addVersionUploadSuccess (response, file) {
            this.loading = false
            if (response) {
                this.$message.success('Add version success!')
                this.$refs.addVersionUpload.clearFiles()
                this.fetchData()
                this.visible = false
            } else {
                this.$message.error(response)
            }
        },
        addVersionUploadError (err, file, fileList) {
            this.loading = false
            this.$refs.addVersionUpload.clearFiles()
            this.$message.error(err.response.data.errorMessage)
        },
        addVersionUpload (content) {
            const formData = new FormData()
            if (content.file.size > 65535) {
                this.$message.warning('File is limited in 65535b!')
                return false
            }
            formData.append('file', content.file)
            formData.append('id', content.data.id)
            this.loading = true
            axios({
                method: 'put',
                url: content.action,
                headers: content.headers,
                data: formData
            }).then(res => {
                this.loading = false
                content.onSuccess(res)
            }).catch(err => {
                this.loading = false
                content.onError(err)
            })
        },
        getHashAction () {
            return process.env.VUE_APP_API_URL + 'backend/secret/hashSecret'
        },
        hashSecret () {
            if (this.searchHashForm.secretType === 'file') {
                if (this.$refs.hashUpload.uploadFiles.length) {
                    this.$refs.hashUpload.submit()
                } else {
                    this.$message.warning('Please select a file')
                }
            } else {
                const { secret, hashValue } = this.searchHashForm
                const formData = new FormData()
                formData.append('secret', secret)
                this.loading = true
                hashSecret(formData).then(response => {
                    this.loading = false
                    if (hashValue === response.secretHashValue) {
                        this.$message.success('Verify secret success')
                        this.searchHashForm.visible = false
                    } else {
                        this.$message.error('Verify secret failed')
                    }
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        hashUploadSuccess (response, file) {
            this.loading = false
            if (response.body.success) {
                console.log(response)
                if (this.searchHashForm.hashValue === response.body.secretHashValue) {
                    this.$message.success('Verify secret success')
                    this.$refs.hashUpload.clearFiles()
                    this.searchHashForm.visible = false
                } else {
                    this.$message.error('Verify secret failed')
                    this.$refs.hashUpload.clearFiles()
                }
            } else {
                this.$message.error(response)
            }
        },
        hashUploadError (err, file, fileList) {
            this.loading = false
            this.$refs.hashUpload.clearFiles()
            this.$message.error(err.response.data.errorMessage)
        }
    }
}
</script>
<style>
em {
    background-color: #eee;
}
</style>
